import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const InitializePlanConfirmationModal = ({ isOpen, onClose, onSubmit, mode = "plan", copyDriversOnly = false }) => {

  // TPX-2219: drivers-only copy gets its own confirmation wording.
  const confirmationTitle =
    mode === "actuals"
      ? "Are you sure you want to copy data from actuals?"
      : copyDriversOnly
        ? "Are you sure you want to copy drivers only from plan?"
        : "Are you sure you want to copy data from plan?";

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth maxWidth="sm">
        
        <DialogTitle
        sx={{
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
        }}
        >
            <Box>
                <Typography
                variant="h4"
                sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#212B36",
                }}>
                 {confirmationTitle}
                </Typography>
                <DialogContent sx={{ padding: "16px" }}>
            <Typography
              id="discard-dialog-description"
              sx={{
                fontSize: "14px",
                lineHeight: "24px",
                fontWeight: 400,
              }}>
              This action cannot be undone.
            </Typography>
        </DialogContent>
            </Box>
            <IconButton onClick={onClose}>
                <ClearIcon sx={{ width: "16px", height: "16px" }} />
            </IconButton>
        </DialogTitle>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "0 16px 16px 16px"
          }}>
          <Button
            onClick={onClose}
            variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            variant="contained"
            color="error"
            sx={{ 
              bgcolor: "#FF5630",
              '&:hover': {
                backgroundColor: '#FF5630',
                boxShadow: 'none',
              },
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InitializePlanConfirmationModal;
